module.exports = __webpack_public_path__ + "img/syukyaku-top-018.77ccf39f.jpg";